import { CACHE_NAMESPACES, CACHE_TTLS, peekCache, readCache, writeCache } from './cacheKeys';
import { getSessionSubject } from './token';

// `organization` is required, not resolved here: every caller writes this after
// awaiting a save, and an omitted organization is resolved at write time — so a
// switch mid-save would file the old organization's timezone under the new
// organization's key. Pass the organization captured before the request.
export const updateCurrentOrganizationTimezoneCache = (timezone: string, organization: string | null, subject = getSessionSubject()): void => {
  if (!organization || !subject) return;
  writeCache({
    scope: 'userOrg',
    namespace: CACHE_NAMESPACES.organizationTimezone,
    storage: 'sessionStorage',
    organization,
    subject,
    value: timezone,
    expiresAt: Date.now() + CACHE_TTLS.organizationTimezone,
  });
};

export const readCurrentOrganizationTimezoneCache = (organization: string | null, subject = getSessionSubject()): string | null => {
  if (!organization || !subject) return null;
  return readCache<string>({
    scope: 'userOrg',
    namespace: CACHE_NAMESPACES.organizationTimezone,
    storage: 'sessionStorage',
    organization,
    subject,
    validate: (value) => typeof value === 'string' && value.length > 0,
  });
};

export const peekCurrentOrganizationTimezoneCache = (organization: string | null, subject = getSessionSubject()): string | null => {
  if (!organization || !subject) return null;
  return peekCache<string>({
    scope: 'userOrg',
    namespace: CACHE_NAMESPACES.organizationTimezone,
    storage: 'sessionStorage',
    organization,
    subject,
    validate: (value) => typeof value === 'string' && value.length > 0,
  });
};
